import { defineComponent as _defineComponent } from 'vue'
import BuilderEstimatorHouseUpgradeOptionDesktop from "./BuilderEstimatorHouseUpgradeOptionDesktop.vue";
  import { ref, computed } from "vue";
  import UpgradeOption from "./UpgradeOption.vue";
  import type { OptionalUpgrade } from "@/types/OptionalUpgradeInterface";
  import BuilderEstimatorStepTitle from "./BuilderEstimatorStepTitle.vue";
  import { useIsDesktop } from "@/features/useIsDesktop";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderEstimatorHouseUpgradeOption',
  props: {
    optionalUpgrades: {},
    selectedUpgradeFromForm: {}
  },
  emits: ["onSelectOptionalUpgrade"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const { isDesktop } = useIsDesktop(990);

  const props = __props;

  const emit = __emit;

  const selectedUpgrades = ref<OptionalUpgrade[] | null>(
    props.selectedUpgradeFromForm || null
  );

  const handleUpgradeSelection = (
    upgrade: OptionalUpgrade,
    isSelected: boolean
  ) => {
    emit("onSelectOptionalUpgrade", upgrade, isSelected);
  };

const __returned__ = { isDesktop, props, emit, selectedUpgrades, handleUpgradeSelection, BuilderEstimatorHouseUpgradeOptionDesktop, ref, computed, UpgradeOption, BuilderEstimatorStepTitle, get useIsDesktop() { return useIsDesktop } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})